export default __webpack_public_path__ + "static/media/background_onboarding_responsive.754bf8e8.png";